import React, {
    ReactElement, useEffect, useState,
} from "react";
import { Form } from "react-bootstrap";

import DeflectionSource from "../../../../../components/pickers/deflection-sources/DeflectionSource";
import {
    ChatSettingsDeflection,
    ChatSettingsDeflectionInput,
} from "../../../../../__generated__/api";

export interface Props {
    data?: ChatSettingsDeflection,
    onChange: (menu: ChatSettingsDeflectionInput) => void;
}

export default function DeflectionSettings({ data, onChange }: Props): ReactElement {
    const [identity, setIdentity] = useState<string>();

    useEffect(() => {
        setIdentity(data?.identity);
    }, [data?.identity]);

    useEffect(() => {
        if (identity !== data?.identity) {
            onChange({
                isEnabled: identity !== "",
                identity,
            });
        }
    }, [identity]);

    return (
        <div className="border p-3 roundjed bg-white mt-4">
            <h5 className="mb-3 text-light">
                Deflection
            </h5>

            <Form.Group className="mb-3 mt-3">
                <Form.Label className="fw-bolder">
                    Deflection Source
                </Form.Label>

                <DeflectionSource
                    onSelected={value => {
                        setIdentity(value);
                    }}
                    value={identity}
                />

                <Form.Text>
                    Should deflection be enabled in this channel. If so, what should be the source?
                </Form.Text>
            </Form.Group>

        </div>
    );
}

DeflectionSettings.defaultProps = {
    data: undefined,
};
